import {
    Typography,
    Container,
    Box,
    TextField,
    List,
    ListItem,
    ListItemIcon,
    Avatar,
    Stack,
    Card,
    CardActions,
    CardContent,
    InputAdornment,
    IconButton,
    Slide,
    Fab,
    Tooltip,
    LinearProgress,
    Chip} from '@mui/material';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { useTheme } from '@emotion/react';

import CustomBackdrop from '../../components/backdrop/CustomBackdrop';
import CustomMarkDown from '../../components/custom-markdown/CustomMarkDown';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { actions } from '../../helper/ActionText';
import ApiUrls from '../../helper/ApiUrls';
import useResponsive from '../../hooks/useResponsive';
import { API, PUBLIC_API } from '../../services/axios.service';
import { socket } from '../../services/socket.service';
import i18n from '../../i18n';

const PAGE_BOTTOM_DESKTOP_MERGIN = 15;
const PAGE_BOTTOM_MOBILE_MERGIN = 0;

const languages = {
    "en": "English",
    "bn": "Bangla"
};

const EmbeddedChatBox = () => {
    const themeMode = useSelector((state) => state.dom.config.themeMode);
    const theme = useTheme();
    const params = useParams();
    const mdUp = useResponsive('up', 'md');
    // const botInfo = useSelector((state) => state.chatbox.chosenBot);

    const [message, setMessage] = useState('');
    const [sendingMessage, setSendingMessage] = useState(false);
    const [conversations, setConversations] = useState([]);
    const [fetchingConvo, setFetchingConvo] = useState(false);
    const [showBackdrop, setShowBackdrop] = useState(false);
    const [reply, setReply] = useState('');
    const [sources, setSources] = useState([]);
    const [isConnected, setIsConnected] = useState(socket.connected);

    const storedTopicID = sessionStorage.getItem('topicID');
    const [botInfo, setBotInfo] = useState(false);

    useEffect(() => {
        const fetchBotInfo = async () => {
            try {
                const response = await API.get(`chatbot/public/details/${params.chatbotID}`);
                setBotInfo(response.data.data);
                console.log("response", response.data.data)
            } catch (err) {
                console.log("error", err)
            }
        };

        fetchBotInfo();
    }, [params.chatbotID])

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (storedTopicID) {
            const fetchConversations = async () => {
                setLoading(true);
                setError(null);
                try {
                    const response = await API.get(`topics/${storedTopicID}/messages/${params.token}`);
                    console.log("response", response)
                    setConversations(response.data.data);
                } catch (err) {
                    setError(err.response ? err.response.data : { error: 'An unknown error occurred' });
                } finally {
                    setLoading(false);
                }
            };
            fetchConversations();

        }
        // console.log("historyDel", historyDel)
    }, [params.chatbotId]);

    const [agentAction, setAgentAction] = useState(null);

    //  creating the unique socket id 
    const generateUniqueID = () => {
        const timestamp = Date.now();
        const randomValue = Math.floor(100000 + Math.random() * 900000); // 6-digit random value
        return `${timestamp}${randomValue}`;
    };

    //  saving it in localStorage
    const getUniqueSocketBroadcastID = () => {
        let socketBroadcastID = localStorage.getItem('socket_broadcast_id');
        if (!socketBroadcastID) {
            socketBroadcastID = generateUniqueID();
            localStorage.setItem('socket_broadcast_id', socketBroadcastID);
        }
        return socketBroadcastID;
    };

    function onSocketMessageEvent(value) {
        // console.log('sock value -- ', actions.searchingWeb, value.action, actions.searchingWeb === value.action);
        const { data, action } = value;
        console.log(`socket data:`,data.message);
        console.log(`socket call for: ${action} with ${data}`);

        const currentAction = actions[action];

        if (currentAction.systemText === actions.final_answer.systemText) {
            setReply(`${data.message.content}`);
            setSources(data.sources||null);
            setAgentAction(null);
        }
        else if (currentAction.systemText === actions.human_reply.systemText) {
            setAgentAction(null);
        }
        else {
            setAgentAction(currentAction);
        }
    }

    function onConnect() {
        console.log('***** sock connected *******');
        setIsConnected(true);
    }

    function onDisconnect() {
        console.log('***** sock disconnected *******');
        setIsConnected(false);
    }

    useEffect(() => {
        const socketBroadcastID = getUniqueSocketBroadcastID();
        socket.on('connect', onConnect);
        socket.on('disconnect', onDisconnect);
        // socket.on(`agent/${botInfo.created_by}`, onSocketMessageEvent);
        socket.on(`agent/${socketBroadcastID}`, onSocketMessageEvent);

        return () => {
            socket.off('connect', onConnect);
            socket.off('disconnect', onDisconnect);
            // socket.off(`agent/${botInfo.created_by}`, onSocketMessageEvent);
            socket.off(`agent/${socketBroadcastID}`, onSocketMessageEvent);
        };
    }, []);


    useEffect(() => {
        if (conversations.length > 0) {
            const lastMessageListItem = document.getElementById(`convo_${conversations.length - 1}`);
            if (lastMessageListItem) {
                lastMessageListItem.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            }
        }
    }, [conversations]);

    const handleMessageInputKeyDown = (e) => {
        if (e.key === 'Enter' && e.shiftKey) {
            e.preventDefault();
            setMessage((prev) => `${prev}\n`);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (message.trim().length === 0) {
                setMessage((prev) => `${prev}\n`);
            } else {
                sendMessage();
            }
        }
    };


    useEffect(() => {
        if (sendingMessage) {
            sendMessageRESTCall();
        }
    }, [sendingMessage]);

    const sendMessageRESTCall = async () => {
        const payload = {
            message: conversations[conversations.length - 1].content,
            language: languages[i18n.language]
        };
        // if (topicInfo) {
        //     // payload.topic_id = topicInfo.id;
        // }
        if (storedTopicID) {
            payload.topic_id = storedTopicID;
        }

        // Get or create the unique socket broadcast ID
        const socketBroadcastID = getUniqueSocketBroadcastID();
        payload.socket_broadcast_id = socketBroadcastID;

        try {
            const response = await PUBLIC_API.post(ApiUrls.SEND_MESSAGE_EMBED(params.chatbotID, params.token), payload);
            // Assuming the response contains the topic ID
            const topicID = response.data.data.topic.id;
            if (topicID) {
                sessionStorage.setItem('topicID', topicID);
            }
        } catch (err) {
            console.log('chat call rest err', err);
        } finally {
            setSendingMessage(false);
        }
    };

    useEffect(() => {
        if (String(reply).trim().length > 0) {
            if (conversations.length > 0 && conversations[conversations.length - 1].type === 'action') {
                const lastConvo = conversations[conversations.length - 1];
                lastConvo.content = reply;
                lastConvo.sources = sources;
                lastConvo.type = "ai";
                setConversations([...conversations.slice(0, -1), lastConvo]);
            } else {
                setConversations([...conversations, { content: reply, type: 'ai', sources }]);
            }
        }
    }, [reply]);

    useEffect(() => {
        const textToShow = agentAction?.displayText;
        if (textToShow && String(textToShow).trim().length > 0) {
            setConversations([...conversations, { content: textToShow, type: 'action', sources }]);
        }
    }, [agentAction]);


    const sendMessage = async (customMessage = '') => {
        const contentToSend = customMessage || message;
        if (String(contentToSend).trim().length > 0) {
            setReply('');
            setSources([]);
            setSendingMessage(true);
            setConversations([...conversations, { content: contentToSend, type: 'human' }]);
            if (!customMessage) {
                setMessage('');
            }
        }
    };

    const handleNewTopicID = () => {
        sessionStorage.removeItem('topicID');
        setConversations([]);
    };

    return (
        <>
            <Page title="Chat">
                <CustomBackdrop open={showBackdrop} />
                <Container sx={{ background: '#fff', paddingLeft: '0px', paddingRight: '0px' }} maxWidth="xl">
                    <Stack direction={'column'} spacing={1} justifyContent={'space-between'} margin={"auto"} maxWidth={'lg'} height={"100vh"} >
                        <Slide direction="down" in timeout={1000}>
                            <Card
                                sx={() => ({
                                    height: `calc(100vh - ${mdUp ? PAGE_BOTTOM_DESKTOP_MERGIN : PAGE_BOTTOM_MOBILE_MERGIN}vh)`,
                                    // minWidth: mdUp ? '80%' : '100%',
                                    boxShadow: "none",
                                    // padding: "1rem"

                                })}
                            >
                                <Box sx={{ boxShadow: 'rgba(17, 17, 26, 0.1) 0px 1px 0px', position: 'fixed', top: '0px', display: 'flex', alignItems: 'center', height: '55px', width: '100%', zIndex: '99999', background: '#fff' }}>
                                    {
                                        botInfo?.name &&
                                        <Typography sx={{ fontWeight: '500', fontSize: '18px', pl: '20px' }}>
                                            {botInfo?.name}
                                        </Typography>
                                    }
                                    <Tooltip arrow placement="left" title={'New Chat'}>
                                        <IconButton sx={theme => ({ alignSelf: "flex-end", color: theme.palette.text.primary, padding: '2px', position: 'absolute', top: '13px', right: '45px' })} onClick={handleNewTopicID} size='small' variant='primary' type='button'>
                                            <Iconify icon="bitcoin-icons:plus-filled" sx={{ width: 26, height: 26, }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <CardContent
                                    sx={{
                                        display: "flex",
                                        flexDirection: 'column',
                                        overflowY: 'auto',
                                        // height: `calc(100vh - ${mdUp ? PAGE_BOTTOM_DESKTOP_MERGIN : 15}vh)`,
                                        height: "calc(100% - 65px)",
                                        position: 'relative',
                                        padding: '0px 16px',
                                        paddingTop: '55px',
                                        // '&::-webkit-scrollbar': { width: '5px', }
                                    }}
                                >
                                    {
                                        botInfo && <>
                                            {fetchingConvo ? (
                                                <LinearProgress variant="indeterminate" />
                                            ) : (
                                                <List sx={{ height: '100%' }}>
                                                    {conversations && conversations.length > 0 ? (
                                                        conversations.map((item, idx) => (
                                                            <Slide key={idx} in direction="right">

                                                                <ListItem sx={{ padding: '8px 4px', borderRadius: '6px', '&:hover': { bgcolor: '#fff' }, }} key={idx} id={`convo_${idx}`}>
                                                                    <ListItemIcon align="left" sx={{ alignSelf: 'flex-start', minWidth: '47px' }}>
                                                                        <Tooltip title={item.type === 'human' ? 'You' : botInfo.name} arrow placement="left">
                                                                            <Fab
                                                                                size="small"
                                                                                sx={{
                                                                                    border: themeMode === 'dark' ? '1px white solid' : 'none',
                                                                                    background: theme.palette.background.paper,
                                                                                    '&:hover': {
                                                                                        background: theme.palette.background.paper,
                                                                                    },
                                                                                }}
                                                                            >
                                                                                {/* <Iconify icon={'line-md:account-small'} width={25} height={25} color="text.primary" /> */}
                                                                                {item.type === 'ai' && botInfo.persona_photo ? (
                                                                                    <Avatar src={botInfo.persona_photo} alt={botInfo.persona_name} />
                                                                                ) : (
                                                                                    <Iconify
                                                                                        icon={'line-md:account-small'}
                                                                                        width={25}
                                                                                        height={25}
                                                                                        color="text.primary"
                                                                                    />
                                                                                )}
                                                                                {/* {item.type === 'human' && user.photo ? (
                                                                                    <Avatar src={user.photo} alt={user.first_name} />
                                                                                ) : (
                                                                                    <Iconify
                                                                                        icon={'line-md:account-small'}
                                                                                        width={25}
                                                                                        height={25}
                                                                                        color="text.primary"
                                                                                    />
                                                                                )} */}
                                                                            </Fab>

                                                                        </Tooltip>
                                                                    </ListItemIcon>
                                                                    <Tooltip title={moment(item.created_at).format('lll')} arrow placement="top">
                                                                        <Box sx={{ wordBreak: 'break-word', fontSize: item.type === 'human' ? '15px' : '14px', lineHeight: '23px', padding: '10px', borderRadius: '16px', borderTopLeftRadius: '0px', fontWeight: item.type === 'human' && '500', color: item.type === 'human' && '#fff', background: item.type === 'human' ? 'rgb(0, 170, 229)' : '#F3F4F6' }}>
                                                                            {item.type === 'human' ? item.content :
                                                                                <div style={{ display: 'flex', alignItems: "center" }}>
                                                                                    {(agentAction && idx === conversations.length - 1) ? (
                                                                                        <>
                                                                                            <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'center', marginTop: '3px' }}>
                                                                                                <span>{item.content}</span>
                                                                                                <Iconify icon={agentAction.icon} height={30} width={50} />
                                                                                            </div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <Box sx={{ width: '100%', overflowX: 'hidden' }}>
                                                                                            <CustomMarkDown key={idx} content={item.content} />
                                                                                            <Stack mt={1} direction="row" alignItems="left" overflow={"auto"} flexWrap="wrap" sx={{ overflowX: 'hidden' }}>
                                                                                                {item.sources && item.sources.map((source, idx) => (
                                                                                                    <Tooltip title={source.title} key={idx}>
                                                                                                        <Chip sx={{ margin: 0.5 }} label={`${String(source.title).slice(0, 20)}...`} variant="outlined" onClick={() => {
                                                                                                            window.open(source.source, "_blank");
                                                                                                        }} />
                                                                                                    </Tooltip>
                                                                                                ))
                                                                                                }
                                                                                            </Stack>

                                                                                        </Box>
                                                                                    )}
                                                                                </div>
                                                                            }
                                                                        </Box>
                                                                    </Tooltip>
                                                                    {/* <ListItemText
                                                                        sx={{ wordBreak: 'break-word' }}
                                                                        align="left"
                                                                        primary={
                                                                            item.type === 'human' ? item.content : <CustomMarkDown content={item.content} />
                                                                        }
                                                                        primaryTypographyProps={{ fontSize: '14px' }}
                                                                    /> */}
                                                                </ListItem>
                                                            </Slide>
                                                        ))
                                                    ) : (
                                                        <Box
                                                            sx={(theme) => ({
                                                                height: '100%',
                                                                position: 'relative',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                flexDirection: 'column',
                                                                [theme.breakpoints.down('sm')]: {
                                                                    justifyContent: 'flex-start',
                                                                },
                                                            })}
                                                        >
                                                            <Box
                                                                sx={(theme) => ({
                                                                    height: '100%',
                                                                    width: '100%',
                                                                    position: 'relative',
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    flexDirection: 'column',
                                                                    [theme.breakpoints.down('sm')]: {
                                                                        justifyContent: 'flex-start',
                                                                    },
                                                                })}
                                                            >
                                                                <Box
                                                                    sx={() => ({
                                                                        textAlign: 'center',
                                                                        paddingBottom: '130px',
                                                                    })}
                                                                >
                                                                    {botInfo.persona_photo ? (
                                                                        <Avatar
                                                                            sx={(theme) => ({
                                                                                margin: '0 auto',
                                                                                marginBottom: '15px',
                                                                                height: 100,
                                                                                width: 100,
                                                                                [theme.breakpoints.down('md')]: {
                                                                                    marginBottom: '15px',
                                                                                },
                                                                            })}
                                                                            src={botInfo.persona_photo}
                                                                            alt={botInfo.persona_name}
                                                                        />
                                                                    ) : (
                                                                        <Iconify icon={'line-md:account-small'} width={100} height={100} />
                                                                    )}

                                                                    <Typography variant="h5" gutterBottom>
                                                                        How can i help you today ?
                                                                    </Typography>
                                                                </Box>
                                                                <Box
                                                                    className={'chat-suggested-text'}
                                                                    sx={{
                                                                        position: 'absolute',
                                                                        top: '155px',
                                                                        display: 'grid',
                                                                        gridTemplateColumns: '1fr 1fr',
                                                                        columnGap: 4,
                                                                    }}
                                                                >
                                                                    {botInfo.sample_prompts && botInfo.sample_prompts.map((el, i) => (
                                                                        <Typography
                                                                            key={i}
                                                                            onClick={() => {
                                                                                // const promptMessage = "Tell me about yourself.?";
                                                                                sendMessage(el);
                                                                            }}
                                                                            variant="p"
                                                                            sx={{
                                                                                cursor: 'pointer',
                                                                                backgroundColor: theme.palette.background.paper,
                                                                                border: `1px solid ${theme.palette.divider}`,
                                                                                borderRadius: '10px',
                                                                                padding: theme.spacing(1, 2),
                                                                                margin: theme.spacing(1, 0),
                                                                                '&:hover': {
                                                                                    backgroundColor: theme.palette.action.hover,
                                                                                },
                                                                                display: 'inline-block',
                                                                            }}
                                                                        >
                                                                            {el}
                                                                        </Typography>
                                                                    ))}
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </List>
                                            )}
                                        </>
                                    }

                                    {/* <Divider /> */}
                                </CardContent>
                                {/* prompt */}
                                <CardActions sx={{ pb: '0px', px: '16px', }}>
                                    <TextField
                                        disabled={sendingMessage}
                                        autoComplete={false}
                                        size="small"
                                        id="outlined-basic-email"
                                        label={
                                            `Ask ${botInfo.name} something`
                                        }
                                        value={message}
                                        multiline
                                        minRows={1}
                                        maxRows={5}
                                        onChange={(e) => setMessage(e.target.value)}
                                        fullWidth
                                        error={message.trim().length > 65000}
                                        helperText={message.trim().length > 65000 ? 'Message is too long' : ''}
                                        onKeyDown={handleMessageInputKeyDown}
                                        InputLabelProps={{
                                            sx: {
                                                pt: '5px',
                                                fontWeight: '300',
                                                fontSize: '14px'
                                            },
                                        }}
                                        InputProps={{
                                            sx: {
                                                padding: '13px 12px', // padding inside the textarea only
                                            },
                                            endAdornment: (
                                                <>
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            disabled={sendingMessage || message.trim().length === 0 || message.trim().length > 65000}
                                                            onClick={() => sendMessage()}
                                                            size="medium"
                                                            type="button"
                                                            variant="contained"
                                                        >
                                                            <Iconify
                                                                color={theme.palette.text.primary}
                                                                icon={sendingMessage ? 'svg-spinners:8-dots-rotate' : 'mdi:send-variant-outline'}
                                                            />
                                                        </IconButton>
                                                    </InputAdornment>
                                                </>
                                            ),
                                        }}
                                    />
                                    {/* <Fab extended size='small' color={theme.palette.primary.main} aria-label="add"><SendIcon/></Fab> */}
                                </CardActions>
                            </Card>

                        </Slide>
                        <Typography style={{ marginTop: '0px', marginBottom: '10px' }} sx={{ fontWeight: '500' }} textAlign="center" gutterBottom fontFamily={'roboto'} fontSize={12}>
                            Powered by <Link style={{ color: '#00AAE5', fontWeight: '500' }} to='https://shadhinlab.com/' target='_blank'>Shadhin Lab LLC</Link>
                        </Typography>
                    </Stack>
                </Container>
                {/* <Dialog open TransitionComponent={Transition}>
                    <Stack padding={'20px'} height="100%" direction="column" spacing={2}>
                        <FormControl size="medium">
                            <TextField
                                fullWidth
                                required
                                size="small"
                                id="name"
                                name="name"
                                value={botForm.values.name}
                                onChange={botForm.handleChange}
                                error={botForm.errors.name && botForm.touched.name}
                                helperText={botForm.touched.name ? botForm.errors?.name : undefined}
                                placeholder="type your name"
                                label="Name"
                                disabled={botForm.isSubmitting}
                            />
                        </FormControl>
                        <FormControl size="medium">
                            <TextField
                                fullWidth
                                required
                                size="small"
                                id="email"
                                name="email"
                                value={botForm.values.email}
                                onChange={botForm.handleChange}
                                error={botForm.errors.email && botForm.touched.email}
                                helperText={botForm.touched.email ? botForm.errors?.email : undefined}
                                placeholder="type your email address"
                                label="Email"
                                disabled={botForm.isSubmitting}
                            />
                        </FormControl>
                    </Stack>

                    <DialogActions sx={{paddingRight: '20px'}}>
                        <LoadingButton variant='outlined' type="button" loading={botForm.isSubmitting} onClick={addEditBot}>Save</LoadingButton>
                    </DialogActions>
                </Dialog> */}
            </Page>
        </>
    );
};

export default EmbeddedChatBox;
